module.exports = __webpack_public_path__ + "img/icon-burger.b6eacc69.svg";